'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NitroDataGrid = require('./NitroDataGrid');

var _NitroDataGrid2 = _interopRequireDefault(_NitroDataGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NitroDataGrid2.default;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-data-grid/index.js
// module id = 178
// module chunks = 4